function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSunRise = function SvgSunRise(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1449.011 997.563"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 595.418 70.742-122.81 442.704 218.418-295.373-444.592 128.1-72.894 303.144 456.289V0h150.377v629.829l303.144-456.289 128.1 72.894-295.373 444.592 442.704-218.418 70.742 122.81-533.014 262.974h440.281v139.171H92.733V858.392h440.281z",
    "data-name": "Layer 1",
    style: {
      fill: "#a25138"
    }
  })));
};
export default SvgSunRise;